export * from './lib/components';
export { useSelectBedsTitle } from './lib/hooks/useSelectBedsTitle';
export { useSelectPriceTitle } from './lib/hooks/useSelectPriceTitle';
export { getUpdatedQuery } from './lib/utils/getUpdatedQuery';
export { default as forSalePricesMobile } from './lib/config/for-sale-prices-mobile.json';
export { default as toRentPricesMobile } from './lib/config/to-rent-prices-mobile.json';
export { formatSearchPath } from './lib/utils/formatSearchPath';

/*
Todo: cleanup optimizely experiment once complete
---
SR-1932 Display Recent locations and categorise autosuggestions within search initiation
*/
export { useSearchBarExperiment } from './lib/temporary/useSearchBarExperiment';
